<template>
  <div>
    <div class="row">
      <div class="col-4 d-flex">
        <div class="form-group mr-1">
          <label for="filter_string">Filtrs</label>
          <input type="text" class="form-control" v-model="filter_string">
        </div>
        <div class="form-group align-self-end ml-1">
          <input type="button" :class="{'disabled':loading==true}" class="btn btn-primary inline" value="Meklēt" @click="getItemCollections()">
          <input type="button" class="btn btn-outline-primary inline" value="Notīrīt filtru" @click="clearFilter()">
        </div>
      </div>
      <div class="col-8 d-flex justify-content-end">
        <div class="form-group align-self-end">
          <button :class="{'disabled':loading==true}" class="btn btn-primary" data-toggle="modal" data-target="#modal-new">Pievienot jaunu kolekciju</button>
        </div>
      </div>
      <div class="modal fade" tabindex="-1"  :id="'modal-new'" ref="modal">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header bg-primary text-white">
              <h5 class="modal-title">Jauna kolekcijas</h5>
              <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">

                <div class="col-12">
                  <div class="form-group">
                    <label for="title">Nosaukums</label>
                    <input class="form-control" type="text" v-model="new_title">
                    <small class="text-danger" v-if="errors && errors.new_title">{{errors.new_title[0]}}</small>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label for="item_type">Kolekcijas priekšmetu veids</label>
                    <select name="item_type" id="item_type" class="form-control" v-model="item_type">
                      <option value="Audio-vizuālie un IT priekšmeti">Audio-vizuālie un IT priekšmeti</option>
                      <option value="Dabas Priekšmeti">Dabas Priekšmeti</option>
                      <option value="Jāprecizē">Jāprecizē</option>
                      <option value="Lietiskie priekšmeti">Lietiskie priekšmeti</option>
                      <option value="Rakstiskie priekšmeti">Rakstiskie priekšmeti</option>
                      <option value="Tēlojošie priekšmeti">Tēlojošie priekšmeti</option>
                    </select>
                    <small class="text-danger" v-if="errors && errors.item_type">{{errors.item_type[0]}}</small>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label for="nmkk_number">NMKK kolekcijas numurs</label>
                    <input class="form-control" type="text" v-model="nmkk_number">
                    <small>NMKK kolekcijas numurs, kas izveidots pievienojot kolekciju NMKK (2003V00105)</small>
                    <small class="text-danger d-block" v-if="errors && errors.nmkk_number">{{errors.nmkk_number[0]}}</small>
                  </div>
                </div>
                <div class="col-12 text-right" >
                  <button class="btn btn-primary" @click="create()" v-if="new_title && modal_loading == false">Pievienot</button>
                  <button v-else-if="modal_loading == true" class="btn btn-primary" disabled>Notiek pievienošana</button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="results">
      <div class="loader" v-show="loading">
        <img src="/images/loading.svg" rel="preload" alt="Notiek ielāde..">
      </div>
      <table class="table table-responsive-xl table-hover ">
        <thead class="bg-primary text-white">
        <tr>
          <th>Nosaukums</th>
          <th>Priekšmetu skaits</th>
          <th>NMKK numurs</th>
          <th>Priekšmetu veids</th>
          <th class="text-center">Darbības</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item_collection in item_collections">
          <td>{{item_collection.title}}</td>
          <td>{{item_collection.items_count}}</td>
          <td>{{item_collection.nmkk_number}}</td>
          <td>{{item_collection.item_type}}</td>
          <td>
            <item-collection-component  :item_collection="item_collection" :key="item_collection.id"></item-collection-component>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="pagination" v-if="pagination.show_pagination">
        <div class="pages">
          <div class="page" @click="changePage(1)" v-if="pagination.show_first_page">1</div>
          <div class="delimiter" v-if="pagination.show_first_page_divider">...</div>
          <div class="page" @click="changePage(page)" v-for="page in pagination.prev_pages" :key="page">{{page}}</div>
          <div class="page currentPage"  :key="pagination.current_page">{{pagination.current_page}}</div>
          <div class="page" @click="changePage(page)" v-for="page in pagination.next_pages" :key="page">{{page}}</div>
          <div class="delimiter" v-if="pagination.show_last_page_divider">...</div>
          <div class="page" @click="changePage(pagination.total_page_count)" :key="pagination.total_page_count" v-if="pagination.show_last_page">{{pagination.total_page_count}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:['item_collections_prop'],
  mounted() {
    setTimeout(() => {
      this.getItemCollections();
    },100);
    var that = this;
    EventBus.$on('item_collections_list_updated', (item_collections_list) =>{
      setTimeout(() => {
        EventBus.$emit('should_update_childs', item_collections_list);
      },500);
    })

    EventBus.$on('should_reload', (item_titles_list) =>{
      setTimeout(() => {
        that.getItemCollections(that.pagination.current_page)
      },100);
    })
  },
  data()
  {
    return{
      item_collections:[],
      loading: true,
      modal_loading:false,
      filter_string:"",
      filter_items_per_page:50,
      pagination:[],
      errors:[],
      new_title:"",
      nmkk_number:"",
      item_type:"",
    }
  },
  methods:{
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    getItemCollections(page = 1){
      this.loading = true;
      var that = this;
      var filterData = {
        title: that.filter_string,
        page:page,
        items_per_page: that.filter_items_per_page
      };
      axios.post('/dashboard/api/item-collections',filterData)
          .then(response => {
            that.item_collections = response.data.collections;
            that.pagination = response.data.pagination;
            that.loading = false;
            EventBus.$emit('item_collections_list_updated',response.data.all_collections);
            that.scrollToTop();
          }).catch(err =>{

      })
    },
    create()
    {
      this.errors = [];
      this.modal_loading = true;
      var that = this;
      var data = {
        title: this.new_title,
        nmkk_number: this.nmkk_number,
        item_type: this.item_type,
      };
      axios.post('/dashboard/api/create_collection',data)
          .then(response => {
            that.modal_loading = false;
            if(response.data.status == 'ok')
            {
              $('#modal-new').modal('hide');
              that.$toast.open(response.data.message);
              EventBus.$emit('should_reload');
              this.new_title = "";
            }
            else {
              that.errors = response.data.errors;
              that.$toast.warning(response.data.message);
            }
          })
    },
    changePage(page)
    {
      this.getItemCollections(page)
    },
    clearFilter()
    {
      this.filter_string = "";
      this.getItemCollections(1)
    }
  }


}
</script>

<style lang="scss" scoped>
@use "sass:color";
@import '../../../sass/variables';
.results{
  position:relative;
  .loader{
    cursor: progress;
    position:absolute;

    width:100%;
    height:100%;
    display:flex;
    align-items: center;
    justify-content: center;
    background:rgba(255,255,255,0.7);
    img{
      width:100px;
      height:100px;
    }

  }
}
.pagination{
  margin-top:20px;
  padding-top:20px;
  border-top:solid 2px #777;
  .pages{
    display:flex;
    margin:auto;
    .page{
      width:32px;
      height:32px;
      margin:0 10px;
      display:flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-radius:100%;
      font-weight: 700;
      transition: all .2s ease-in-out;
      &:hover{
        background:$blue;
        color:#fff;
      }
    }
    .delimiter{
      width:20px;
      height:32px;
      margin:0 0px;
      display:flex;
      color:#333;
      align-items: center;
      justify-content: center;
    }
    .currentPage{
      background:$blue;
      color:#fff;
      cursor:auto;
    }

  }
}
</style>